import { AxiosResponse } from 'axios';
import { conexao } from '../../../../offline/conexao';


export const responseInterceptor = (response: AxiosResponse) => {
  conexao.marcarOnline();
  return response;
};
